/* ============
 * Deposit System Transformer
 * ============
 */

import Transformer from './transformer';

export default class DepositSystemTransformer extends Transformer {

  static fetch(item) {
    return {
      id: item.id,
      name: item.name,
    };
  }

  static send(item) {
    return {
      id: item.id,
      name: item.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/depositSystem.js